<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      {{headerText}}
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
  </div>

  <form [formGroup]="inputForm">
  <div mat-dialog-content>
    <div class="row reset-row">
      <div class="col-md-12 eip-pb-10">
            <mat-form-field style="width:100%;">
                <mat-label>{{inputLabel}}</mat-label>
                <input matInput required formControlName="ctrlInputText">
                <mat-error *ngIf="inputForm.get('ctrlInputText').hasError('required')">
                    Title is required
                  </mat-error>
              </mat-form-field>
          </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary" id="btnSave" (click)="SaveData()">Save</button>
    </div>
  </div>
</form>
